import React, { useState } from 'react';
import { Dialog, DialogContent, Typography, DialogActions, Button, Toolbar } from '@mui/material';

interface ConfirmDialogProps {
    open?: boolean;
    onClose: (event?: any, reason?: any) => void;
    onConfirm?: () => any;
    message?: React.ReactNode;
}

const ConfirmDialog = (props: ConfirmDialogProps) => {
    const { open, onClose, onConfirm, message } = props;
    const [disabled, setDisabled] = useState(false);

    const action = async () => {
        if (!onConfirm) {
            return;
        }
        setDisabled(true);
        try {
            await onConfirm();
        } catch {

        }
        onClose();
        setDisabled(false);
    };

    return (
        <Dialog
            maxWidth="xs"
            open={open}
            onClose={(event, reason) => {
              if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                if (disabled) return;
              }
              onClose(event, reason);
            }}>
            <Toolbar className='lbtoolbar'>Confirm</Toolbar>
            <DialogContent>
                <Typography style={{whiteSpace: 'pre-wrap'}}>{message}</Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="text" disabled={disabled} onClick={onClose} color="primary">No</Button>
                <Button variant="text" disabled={disabled} onClick={action} color="primary">Yes</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
